/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PlaceOfDeliveryType = 'Undefined' | 'Consumption' | 'Production' | 'Combine' | 'Unspecified' | 'Other';

export const PlaceOfDeliveryType = {
    Undefined: 'Undefined' as PlaceOfDeliveryType,
    Consumption: 'Consumption' as PlaceOfDeliveryType,
    Production: 'Production' as PlaceOfDeliveryType,
    Combine: 'Combine' as PlaceOfDeliveryType,
    Unspecified: 'Unspecified' as PlaceOfDeliveryType,
    Other: 'Other' as PlaceOfDeliveryType
};